import { render, staticRenderFns } from "./HeroVimeoVideo.vue?vue&type=template&id=f5341406&scoped=true&"
import script from "./HeroVimeoVideo.vue?vue&type=script&lang=js&"
export * from "./HeroVimeoVideo.vue?vue&type=script&lang=js&"
import style0 from "./HeroVimeoVideo.vue?vue&type=style&index=0&id=f5341406&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5341406",
  null
  
)

export default component.exports